import {Event as Event_V3} from '@wix/ambassador-events-v3-event/types'
import React from 'react'
import {Members} from '../../../../members'
import s from './members.scss'

export const MobileCardMembers = ({event, onClick}: {event: ExtendedEvent | Event_V3; onClick?: () => void}) => (
  <div className={s.members} data-hook="ev-list-item-members" onClick={onClick}>
    <Members event={event} listLayout />
  </div>
)
